// src/components/TransactionUploader/TransactionTable.tsx
import React from 'react';
import { Table, Th } from './TransactionUploader.styles';
import TransactionRow from './TransactionRow';
import { RowState } from './types';
import { Proprietario, Inquilino, UnitaImmobiliare, VersamentoEnriched } from '../../services/types/firestoreTypes';


interface Props {
  rows: RowState[];
  owners: Proprietario[];
  tenants: Inquilino[];
  units: UnitaImmobiliare[];
  onAnalyze: (index: number) => void;
  onDeeper: (index: number) => void;
  onVersamentiCreated: (index: number) => void;
  onSaveInline: (
    rowIndex: number,
    versamento: VersamentoEnriched,
    versIndex?: number
  ) => void;
  onDeleteInline?: (rowIndex: number, versIndex: number) => void;
}

const TransactionTable: React.FC<Props> = ({
  rows,
  owners,
  tenants,
  units,
  onAnalyze,
  onDeeper,
  onVersamentiCreated,
  onSaveInline,
  onDeleteInline,
}) => {
  if (rows.length === 0) return null;
  const headers = Object.keys(rows[0].tx);

  return (
    <Table>
      <thead>
        <tr>
          {headers.map(key => (
            <Th key={key}>{key}</Th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((rowState, idx) => (
          <TransactionRow
            key={idx}
            index={idx}
            rowState={rowState}
            owners={owners}
            tenants={tenants}
            units={units}
            onAnalyze={onAnalyze}
            onDeeper={onDeeper}
            onVersamentiCreated={onVersamentiCreated}
            onSaveInline={onSaveInline}
            onDeleteInline={onDeleteInline}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default React.memo(TransactionTable);
